import {removeChildren} from "./remove-children.js";
export const renderExplanation = (formElement, response) => {
  const explanationElement = formElement.querySelector(".quiz-form__explanation");
  const explanation = document.createElement("div");
  explanation.innerText = response.questionResponse;
  explanation.classList.add("headline--3");
  explanationElement.appendChild(explanation);
  explanationElement.classList.remove("hidden");
  removeChildren(formElement.querySelector(".quiz-form__answer-wrapper"));
};
